// extracted by mini-css-extract-plugin
export default {"icon":"appBreadCrumbs_icon__SCILx","breadcrumbs":"appBreadCrumbs_breadcrumbs__Oea6f"};